import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Parse } from 'parse';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faEye, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { PatientService } from 'src/app/admin/services/patient.service';
import { Patient } from 'backend/interfaces/patient.interface';
import { AuthService } from '../auth.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  passwordVisible: boolean = false;
  faPhoneVolume = faPhoneVolume;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private patientService: PatientService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      password: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      name: ['', Validators.required],
      surname: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { 
      return this.loginForm.controls; 
  }

  clearButton() {
    this.loading = false;
  }

  async onSubmit(): Promise<any> {
    this.loading = true;
    this.submitted = true;

    if (this.loginForm.invalid) {
      this.loading = false;
      return;
    }
    const patient: Patient = {
      Name: this.f.name.value,
      Surname: this.f.surname.value,
      Mobile: this.f.mobile.value,
      Email: this.f.email.value,
    }
    const password = this.f.password.value;
    this.authService.signup(patient, password).then(res => {
      this.router.navigate(['/']);
    }).catch(err => alert(err));
    

    // let user = new Parse.User();
    // user.set("Name", this.f.name.value);
    // user.set("Surname", this.f.surname.value);
    // user.set("Mobile", this.f.mobile.value);
    // user.set("username", this.f.email.value);
    // user.set("password", this.f.password.value);
    // user.set("email", this.f.email.value);


    // try {
    //   await user.signUp();
    //   this.router.navigate(['/']);
    // } catch (error) {
    //   // Show the error message somewhere and let the user try again.
    //   alert("Error: " + error.code + " " + error.message);
    // }
  }

    togglePassword(show) {
        this.passwordVisible = show;
    }
}
